<template>
    <div class="bg-white shadow-md rounded">
        <slot></slot>
    </div>
</template>

<script>
    export default {

    }
</script>
